"use strict";

require("./_fake-input-cta");